import { Extension } from '@tiptap/react';

// ConvertKit's `orderedListNumbering` registers `numberingFormat` on
// `orderedList` only. This adds the matching attribute to `bulletList`.
export const BulletListFormats = Extension.create({
  name: 'bulletListFormats',

  addGlobalAttributes() {
    return [
      {
        types: ['bulletList'],
        attributes: {
          numberingFormat: {
            default: null,
            parseHTML: (element) =>
              element.parentElement?.closest('ul') ? null : element.getAttribute('data-numbering-format'),
            renderHTML: (attributes) =>
              attributes.numberingFormat ? { 'data-numbering-format': String(attributes.numberingFormat) } : {},
          },
        },
      },
    ];
  },
});
